import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import LogoText from "./LogoText";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#0B1B2B] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <LogoText size="lg" inverted />
            <p className="mt-4 text-white/60 leading-relaxed max-w-sm">{t("ds.footer.intro")}</p>
            <div className="mt-6 text-sm text-white/70 space-y-1.5">
              <div>📞 +34 621 416 789</div>
              <div>✉ info@doctorsol.es</div>
              <div>📍 Costa del Sol, España</div>
            </div>
          </div>
          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.18em] text-[#F5C24C] mb-4 font-medium">{t("ds.footer.quick")}</div>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><Link to="/hoe-werkt-het" className="hover:text-white">{t("ds.nav.how")}</Link></li>
              <li><Link to="/diensten" className="hover:text-white">{t("ds.nav.services")}</Link></li>
              <li><Link to="/over-ons" className="hover:text-white">{t("ds.nav.about")}</Link></li>
              <li><Link to="/kennisbank" className="hover:text-white">{t("ds.nav.knowledge")}</Link></li>
              <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.18em] text-[#F5C24C] mb-4 font-medium">{t("ds.footer.partners_title")}</div>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><Link to="/voor-installateurs" className="hover:text-white">{t("ds.nav.partners")}</Link></li>
              <li><a href="mailto:info@doctorsol.es" className="hover:text-white">{t("ds.footer.contact_us")}</a></li>
            </ul>
          </div>
          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.18em] text-[#F5C24C] mb-4 font-medium">{t("ds.footer.cta_title")}</div>
            <p className="text-sm text-white/70 mb-5">{t("ds.footer.cta_text")}</p>
            <a href="/#zonnecheck" data-testid="footer-cta"
              className="inline-flex items-center gap-2 bg-[#F5C24C] hover:bg-[#E5AE2F] text-[#0B1B2B] font-medium rounded-full px-6 py-3 text-sm">
              {t("ds.hero.cta_primary")} <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
        <div className="mt-12 pt-7 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-white/50">
          <div>© 2026 DoctorSol · {t("ds.footer.rights")}</div>
          <div className="flex gap-5">
            <a href="/privacy" className="hover:text-white">{t("ds.footer.privacy")}</a>
            <a href="/terms" className="hover:text-white">{t("ds.footer.terms")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
